import React, {useEffect, useState} from "react";
//import FormMap from "./form-map";
import { connect } from "react-redux";
import SlidingPane from "react-sliding-pane";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { getOrganizations } from "../../actions/actions-organizations";
import Organization from "../organization";
import SearchPreview from "../search-preview";
import ClusterMap from "./cluster-map";
import useUrlQuery from "../../hooks/useUrlQuery";
import {useHistory} from "react-router-dom";
import {FiGift, FiGlobe, FiImage, FiMail, FiMapPin, FiPhone} from "react-icons/fi";

const geolocationOptions = {
    enableHighAccuracy: true,
    timeout: 1000 * 60
};

let currentName = ''

const Catalog = props => {

    const {organizations, filtered, currentCountry, getOrganizations, language, wording} = props

    const [browserGeo, setBrowserGeo] = useState(null)

    const [discounts, setDiscounts] = useState(false)

    const {width, height} = useWindowDimensions();


    useEffect(() => {
        if (!organizations?.length) getOrganizations()
    }, []);


    const [panelOpen, setPanelOpen] = useState(false);
    const [panelItem, setPanelItem] = useState(null);


    const openPanel = (item) => {
        setPanelItem(item);
        setPanelOpen(true)
    }

    const organizationsToDisplay = (filtered?.length ? filtered : organizations)


    return (
        <div>

            {/*
            <ClusterMap discounts={discounts} centerObject={panelItem} data={organizationsToDisplay} onSelect={openPanel} centerAddress={centerPoint} showPopup={showPopup} hidePopup={hidePopup} />
            */}
            <div style={{marginLeft: 200, marginTop: 80, width: '100%', height: '90vh', overflowY: 'scroll'}}>
                {organizationsToDisplay.map((item, index) => <div>
                    {index < 50 && <div className={'d-flex wp-100'} style={{ backgroundColor: index % 2 ? '#FFF' : '#F8F8F8', padding: 0, borderBottom: '1px #EEE solid', cursor: 'pointer'}}>
                        <div className='h-100 d-flex-ac' style={{gap: 16, paddingLeft: 20, overflow: 'hidden'}} key={index} onClick={() => openPanel(item)}>
                            {item.Image?.[0]?.url && <img src={item.Image?.[0]?.url} className='w-50 h-50' alt='logo' style={{objectFit: 'cover', borderRadius: 6}} />}
                            {!item.Image?.[0]?.url && <div className='w-50 h-50 d-flex-ac'  style={{border: '#EEE 1px solid', borderRadius: 6, justifyContent: 'center'}} ><FiImage size={18} color={'#DDD'} /></div>}
                            <div className={'wp-100 d-flex-ac'} style={{gap: 20, padding: '10px 0'}}>
                                <div className='d-flex-ac d-web' style={{width: 300, maxHeight: 60}}>
                                    <p className='fs-12 strong'>{item.Name}</p>
                                    <p className='mt-5 pre-line fs-12'
                                       style={{height: 40, overflow: 'hidden'}}>{item.Services}</p>
                                    {item.Discount &&
                                        <div className='d-flex-ac mt-10'><FiGift size={14} color='#FF0000'/><p
                                            className='fs-12 ml-5'>{item.Discount}</p></div>}
                                </div>
                                {(item.Address || item.Country) && <div style={{width: 300}}>
                                    <a href={`https://maps.google.com?q=${item.lat},${item.lng}`}
                                       target={'_blank'} rel="noopener noreferrer">
                                        <div className='cli d-flex-ac fcblack' style={{gap: 6}}>
                                            <FiMapPin size={12} style={{marginTop: 2}}/>
                                            <p className='mt-5 pre-line fs-12'>{`${item.Country}`}</p>
                                        </div>
                                        {item.Address && <p className='mt-10 pre-line fs-12 fcblack'>{`${item.Address}`}</p>}
                                    </a></div>}
                                {(item.Phone || item.Email || item.Website) &&
                                    <div style={{width: 300}}>
                                        {item.Email && <div className='mb-10 cli d-flex-ac' style={{gap: 6}}>
                                            <FiMail size={12} style={{marginTop: 2}}/>
                                            <p className='mt-5 pre-line fs-12'>{`${item.Email}`}</p>
                                        </div>}

                                        {item.Phone && <div className='mb-10 cli d-flex-ac' style={{gap: 6}}>
                                            <FiPhone size={12} style={{marginTop: 2}}/>
                                            <p className='mt-5 pre-line fs-12'>{`${item.Phone}`}</p>
                                        </div>}

                                        {item.Website && <div className='mb-10 cli d-flex-ac' style={{gap: 6}}>
                                            <FiGlobe size={12} style={{marginTop: 2}}/>
                                            <p className='mt-5 pre-line fs-12'>{`${item.Website}`}</p>
                                        </div>}

                                    </div>}
                            </div>
                        </div>
                    </div>}
                </div>)}
            </div>


            <SlidingPane
                isOpen={panelOpen}
                title={wording['card_details'][language]}
                width={width < 400 ? '100%' : 500}
                subtitle=""
                onRequestClose={() => {
                    setPanelOpen(false);
                }}>
                <div>
                    {panelItem && <Organization item={panelItem}/>}
                </div>
            </SlidingPane>

        </div>
    );

}


const mapStateToProps = ({ data: { organizations, filtered, currentCountry }, language: {language, wording}}) => {
    return { organizations, filtered, currentCountry, language, wording };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getOrganizations: getOrganizations(dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Catalog);

